import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';

export default function AlertModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Êtes-vous sûr ?", 
  description = "Cette action est irréversible. Voulez-vous continuer ?",
  confirmText = "Confirmer",
  cancelText = "Annuler"
}) {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[150] flex items-center justify-center p-4 sm:p-0">
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 bg-black/60 backdrop-blur-sm"
            onClick={onClose}
          />

          {/* Modal Panel */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="relative bg-surface rounded-xl shadow-hp-xl border border-workspace w-full max-w-lg overflow-hidden flex flex-col z-10"
          >
            <div className="p-6">
              <div className="sm:flex sm:items-start">
                <div className="mx-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-danger-100 sm:mx-0 sm:h-10 sm:w-10">
                  <AlertTriangle className="h-6 w-6 text-danger-600" aria-hidden="true" />
                </div>
                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3 className="text-lg font-bold text-primary">
                    {title}
                  </h3>
                  <div className="mt-2">
                    <p className="text-sm text-tertiary">
                      {description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-surface-muted px-6 py-4 border-t border-workspace flex flex-col sm:flex-row-reverse gap-3">
              <button
                type="button"
                onClick={onConfirm}
                className="btn btn-danger w-full sm:w-auto"
              >
                {confirmText}
              </button>
              <button
                type="button"
                onClick={onClose}
                className="btn btn-secondary w-full sm:w-auto"
              >
                {cancelText}
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
